import React, { useState } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import Translate from "Components/Translate";
import postData from "Services/postData";

const SendBtn = ({ inputs, passengerInfo, onBeforeSubmit, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const isValid = await onBeforeSubmit();
      
      if (!isValid) {
        toast.current.show({
          severity: "error",
          summary: "Validation Error",
          detail: "Please fill in all required fields correctly",
          life: 3000,
        });
        return;
      }

      // Prepare and send the booking data
      const result = { ...inputs, passenger_information: passengerInfo };
      const response = await postData(result, "/front/booking");
      


      // Close modal and handle success
      if (onSuccess) {
        onSuccess(response);
      }
  
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while submitting the booking",
        life: 3000,
      });
      console.error('Booking submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="flex justify-content-end">
        <Button
          label={<Translate>Send</Translate>}
          icon="pi pi-send"
          loading={loading}
          onClick={handleSubmit}
          className="mt-2"
        />
      </div>
    </>
  );
};

export default SendBtn;
